// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","hide":"Menu_hide__BVAr0","show":"Menu_show__eBoqR","active":"Menu_active__-0Z9R","tooltip":"Menu_tooltip__4rVxv"};